// src/components/LightBoxModal.jsx
import React, { useEffect, useState, useCallback } from "react";

const LightboxModal = ({ isOpen, images = [], initialIndex = 0, onClose }) => {
  const [index, setIndex] = useState(initialIndex);

  // sync index + lock scroll when opened
  useEffect(() => {
    if (!isOpen) return;

    setIndex(initialIndex || 0);

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen, initialIndex]);

  const prev = useCallback(() => {
    setIndex((i) =>
      images.length ? (i === 0 ? images.length - 1 : i - 1) : 0
    );
  }, [images]);

  const next = useCallback(() => {
    setIndex((i) =>
      images.length ? (i === images.length - 1 ? 0 : i + 1) : 0
    );
  }, [images]);

  // keyboard navigation
  useEffect(() => {
    if (!isOpen) return;

    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") prev();
      if (e.key === "ArrowRight") next();
    };

    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen, onClose, prev, next]);

  if (!isOpen || !images || images.length === 0) return null;

  return (
    <div
      className="supplement-lightbox active"
      role="dialog"
      aria-modal="true"
      tabIndex={-1}
      onClick={onClose}
    >
      <button
        className="supplement-lightbox-close"
        aria-label="Close"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
      >
        &times;
      </button>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{ position: "relative" }}
      >
        <img
          src={images[index]}
          alt={`Lightbox ${index + 1}`}
          className="supplement-lightbox-img"
        />

        {images.length > 1 && (
          <>
            <button
              aria-label="Previous image"
              onClick={prev}
              style={{
                position: "absolute",
                left: "-48px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                fontSize: "2rem",
                cursor: "pointer",
                padding: 0,
                lineHeight: 1,
              }}
            >
              ‹
            </button>
            <button
              aria-label="Next image"
              onClick={next}
              style={{
                position: "absolute",
                right: "-48px",
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                fontSize: "2rem",
                cursor: "pointer",
                padding: 0,
                lineHeight: 1,
              }}
            >
              ›
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default LightboxModal;
